import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

// Definiamo le traduzioni
const translations = {
    dk: {
        enbutton: `Engelsk`,
        itbutton: `Italiensk`,
        heroTitle: `Hej, jeg er <span class="text-color-main">Maxim Daniel</span><br />softwareingeni\u00F8r og udvikler.`,
        knowMore: "L\u00E6s mere",
        aboutTitle: "Om mig",
        viewResume: "Karriere",
        viewLive: "Se live",
        aboutDescription:
            "Softwareingeni\u00F8r og webudvikler med en passion for at l\u00E6re og udforske nye teknologier. Erfaren inden for kunstig intelligens og intuitivt applikationsdesign. Jeg bruger logik, kreativitet og sans for detaljer til at skabe praktiske og effektive l\u00F8sninger.",
        aboutGoal: `Mit m\u00E5l er at l\u00E6re og skabe interessante ting 
        <br />
        <br />- Kandidatstuderende p\u00E5 Aalborg Universitet
        <br />- Medlem af Mensa International`,
        sectionEducation: "Uddannelse",
        sectionJob: "Job",
        sectionProjects: "Projekter",

        sectionEduT1: `Master of Science i datalogi <br /> Aalborg Universitet - 2025 - 2027`,
        sectionEducation1: `Jeg er i \u00F8jeblikket indskrevet p\u00E5 Aalborg Universitet og s\u00F8ger et studiejob, hvor jeg kan anvende mine f\u00E6rdigheder, opn\u00E5 praktisk erfaring og bidrage til virkelige projekter sidel\u00F8bende med universitetsprojekterne.`,
        sectionEduT2: `Bachelor i datalogi<br /> Unicam - 2020 - 2023`,
        sectionEducation2: `Jeg afsluttede min bachelor p\u00E5 University of Camerino, hvor jeg fik et solidt fundament i datalogi og besl\u00E6gtede omr\u00E5der. Vi gennemgik emner som matematisk logik, algoritmer og datastrukturer, OOP, databaser, operativsystemer og software engineering. Jeg unders\u00F8gte ogs\u00E5 cloud computing, cybersikkerhed, AI og deep learning samt web- og mobiludvikling. Min bacheloropgave handlede om procedurel generering i Unity, hvor jeg omsatte teoretiske tilgange til praktiske anvendelser.`,
        sectionJob1: `Jeg udviklede webgr\u00E6nseflader og webapps integreret med relationelle databaser og arbejdede p\u00E5 projekter for kommuner med h\u00E5ndtering af registre, bestillinger og andre specifikke applikationer. I \u00F8jeblikket samarbejder jeg med min leder om at administrere en del af virksomhedens milj\u00F8. Hurtig tilpasning til propriet\u00E6re teknologier og nye milj\u00F8er.`,
        sectionJob2: `Universitetspraktik med fokus p\u00E5 webudvikling i ASP.NET og brug af Microsoft Azure-platformen. Deltog i professionelle projekter som en del af et team og opn\u00E5ede erfaring med SQL-databaseadministration, h\u00E5ndtering af kode og brug af Git til samarbejdsbaseret versionsstyring.`,
        sectionProject1: `Webudvikling med HTML, SCSS, JavaScript og Node.js. Oprettede et responsivt website med integreret overs\u00E6ttelse. Konfigurerede manuelt dom\u00E6net, hostet hos en ekstern tjeneste, til at pege p\u00E5 en AWS-instans via DNS og en statisk IP-adresse.`,
        sectionTtp: "Stressdetektion med AI",
        sectionProject2: `Udvikling af et dybt konvolutionelt neuralt netv\u00E6rk (Deep CNN) i Python til stressdetektion ved hj\u00E6lp af b\u00E6rbare sensorer. Sensordata omdannes til billeder for at kunne anvende avancerede maskinl\u00E6ringsmodeller.</br></br>Billederne viser n\u00F8jagtighedstesten, herunder genererede billeder, den opn\u00E5ede n\u00F8jagtighed under testen samt resultaterne. Derudover demonstrerer nogle k\u00F8rselslogfiler under modellens opbygning dens udvikling.`,
        sectionTtp2: "Procedurel genereringsalgoritme i videospil",
        sectionProject3: `Design af algoritmer til procedurel generering af indhold i videospil. Implementeret i Unity 2D, hvor der er opbygget et automatiseret system til generering af baner og labyrinter.</br></br>P\u00E5 billedet ses et rum, der er fuldst\u00E6ndigt genereret af algoritmen, som ogs\u00E5 h\u00E5ndterer placering af fjender, objekter og den procedurelle m\u00F8nstergenerering af dungeon. Kort sagt kan programmet, ud fra en tom sk\u00E6rm, generere en fuldt udbygget labyrint.`,

        contactTitle: "Kontakt",
        contactDescription: "For sp\u00F8rgsm\u00E5l eller henvendelser kan du skrive direkte til mig her:",
        contactCta: "Kontakt mig",
    },
    en: {
        dkbutton: `Danish`,
        itbutton: `Italian`,
        heroTitle: `Hi, I'm <span class="text-color-main">Maxim Daniel</span><br />software engineer and developer.`,
        knowMore: "Know more",
        aboutTitle: "About me",
        viewResume: "Resume",
        viewLive: "See Live",
        aboutDescription:
            "Software Engineer and Web Developer with a passion for learning and exploring new technologies. \
            Experienced in Artificial Intelligence and intuitive application design. I leverage logic, creativity \
            and attention to detail to create practical and effective solutions.",
        aboutGoal:
            `My goal is to learn and create interesting things
            <br />
            <br />- Master Student at Aalborg University
            <br />- Member of Mensa International`,
        sectionEducation: "Education",
        sectionJob: "Jobs",
        sectionProjects: "Projects",

        sectionEduT1: 'Master of Science in Computer Science <br /> Aalborg University - 2025 - 2027',
        sectionEducation1: `Currently enrolled at Aalborg University and looking for a student job where I can apply my skills, gain practical experience, and contribute to real-world projects alongside the university ones.`,
        sectionEduT2: 'Bachelor\'s Degree in Computer Science<br /> Unicam - 2020 - 2023',
        sectionEducation2: `I completed my Bachelor\'s at the University of Camerino, where I gained a strong foundation in computer science and related fields. We covered topics such as mathematical logic, algorithms and data structures, OOP, databases, operating systems, and software engineering. I also explored cloud computing, cybersecurity, AI and deep learning, as well as web and mobile development. My thesis was on procedural generation in Unity, bringing theoretical aproaches in practical applications. `,
        sectionJob1: `I developed web interfaces and web apps integrated with relational databases, working on projects for municipalities, 
                                    managing registries,orders, and other specific applications. Currently, I collaborate with my manager 
                                    in managing aportion of the company environment. Rapid adaptation to proprietary technologies and new environments.`,
        sectionJob2: `University internship focused on web development with ASP.NET and the use of the Microsoft Azure platform. Participated 
                                    in professional projects as part of a team, gaining experience in SQL database management, code handling, 
                                    and the use of Git for collaborative version control.`,
        sectionProject1: `Web development using HTML, SCSS, JavaScript, and Node.js. Created a responsive website with integrated translation. 
                                    Manually configured the domain hosted on an external service to point to an AWS instance via DNS and a 
                                    static IP address.`,
        sectionTtp: "Stress detection through AI",
        sectionProject2: `Development of a deep convolutional neural network (Deep CNN) in Python for stress detection using wearable sensors. Sensory data is converted into images for the application of advanced machine learning models.</br></br>The images show the accuracy test, including generated images, the accuracy achieved during the test, and the results. Additionally, some execution logs during the model's construction demonstrate its progression.`,
        sectionTtp2: "Procedural generation algorithm in video games",
        sectionProject3: `Design of algorithms for the procedural generation of video game content. Implemented in Unity 2D, creating an automated system for generating levels and mazes.</br></br>In the image, you can see a room entirely generated by the algorithm, which also handles the placement of enemies, objects, and the pattern generation of the dungeon procedurally. Simply put, starting from a blank screen, the program can generate a fully-fledged maze.`,


        contactTitle: "Contact",
        contactDescription: "For anything you can write directly to me here:",
        contactCta: "Contact me",
    },
    it: {
        enbutton: `Inglese`,
        dkbutton: `Danese`,
        heroTitle: `Ciao, sono <span class="text-color-main">Maxim Daniel</span><br />ingegnere del software e sviluppatore.`,
        knowMore: "Scopri di pi\u00F9",
        aboutTitle: "Su di me",
        viewResume: "Curriculum",
        viewLive: "Vedi Live",
        aboutDescription:
            "Software Engineer e Web Developer con una passione per l'apprendimento e l'esplorazione di nuove tecnologie. \
            Con esperienza in Intelligenza Artificiale e progettazione di applicazioni intuitive. Unisco logica, \
            creativit\u00E0 e attenzione ai dettagli per creare soluzioni pratiche ed efficaci.",
        aboutGoal:
            `Il mio obbiettivo \u00E8 imparare e creare cose interessanti
            <br />
            <br />- Studente magistrale presso l'universit\u00E0 di Aalborg
            <br />- Membro del Mensa International`,
        sectionEducation: "Studi",
        sectionJob: "Lavori",
        sectionProjects: "Progetti",

        sectionEduT1: `Laurea Magistrale in Informatica <br /> Aalborg University - 2025 - 2027`,
        sectionEducation1: `Attualmente iscritto all'Aalborg University e in cerca di un lavoro da studente in cui poter applicare le mie competenze, acquisire esperienza pratica e contribuire a progetti reali accanto a quelli universitari.`,
        sectionEduT2: `Laurea Triennale in Informatica<br /> Unicam - 2020 - 2023`,
        sectionEducation2: `Ho conseguito la Laurea Triennale presso l'Universit\u00E0 di Camerino, dove ho acquisito una solida base in informatica e discipline correlate. Abbiamo trattato argomenti come logica matematica, algoritmi e strutture dati, OOP, basi di dati, sistemi operativi e ingegneria del software. Ho inoltre approfondito cloud computing, cybersecurity, IA e deep learning, nonch\u00E9 sviluppo web e mobile. La mia tesi riguardava la generazione procedurale in Unity, portando approcci teorici ad applicazioni pratiche.`,
        sectionJob1: ` Ho sviluppato interfacce web e web app integrate con database relazionali,
                                    occupandomi di progetti per enti comunali, gestione di anagrafiche, ordini
                                    e altre applicazioni specifiche. Attualmente collaboro con il mio responsabile
                                    nella gestione di una parte dell'ambiente aziendale.
                                    Adattamento rapido a tecnologie proprietarie e nuovi ambienti.`,
        sectionJob2: ` Tirocinio universitario dove mi sono occupato di sviluppo web con
                                    ASP.NET e utilizzato la piattaforma Microsoft Azure. Ho partecipato a
                                    progetti professionali lavorando in team, acquisendo esperienza
                                    nell'utilizzo di database SQL, nella gestione del codice e
                                    nell'uso di Git per il versionamento collaborativo.`,
        sectionProject1: ` Sviluppo Web in HTML, SCSS, JavaScript & Node.js, realizzato un sito web
                                    responsive con traduzione integrata. Configurato manualmente il dominio
                                    hostato su un servizio esterno per puntare a un'istanza AWS tramite DNS
                                    e IP statico.`,
        sectionTtp: "Individuazione dello stress tramite AI",
        sectionProject2: ` Sviluppo di una rete neurale convoluzionale profonda (Deep CNN)
                                    in Python per la rilevazione dello stress attraverso sensori indossabili.
                                    Dati sensoriali vengono convertiti in immagini per l'applicazione di modelli
                                    avanzati di machine learning.
                                    </br></br>Nelle immagini si pu\u00F2 notare il test dell'accuratezza, dove si vedono le immagini
                                    generate, insieme all'accuratezza raggiunta durante il test e esito. Poi ci sono alcune
                                    righe di esecuzione durante la costruzione del modello che ne mostrano la progressione.`,
        sectionTtp2: "Algoritmo di generazione procedurale in ambito videoludico",
        sectionProject3: `Progettazione di algoritmi per la generazione procedurale di contenuti videoludici.
                                    Implementazione effettuata in Unity 2D per il sistema automatizzato per la creazione di livelli e labirinti.
                                    </br></br>Nell'immagine si pu\u00F2 vedere una stanza creata interamente dall'algoritmo, viene gestito anche
                                    il piazzamento di nemici, oggetti e la creazione di un pattern del dungeon sempre 
                                    proceduralmente generato. In termini semplici partendo da una schermata vuota il 
                                    programma \u00E8 in grado di generare un vero e proprio labirinto.`,

        contactTitle: "Contatto",
        contactDescription: "Per qualsiasi cosa puoi scrivermi direttamente qui:",
        contactCta: "Contattami",

    },
};
// --- Language switcher (no reload needed) ---
function changeLanguage(lang) {
    localStorage.setItem("lang", lang);
    updateContent(lang);
    //location.reload();
}

// Expose globally if you still call it from HTML
window.changeLanguage = changeLanguage;

// --- Apply translations by key -> matching #id or .class ---
function updateContent(lang) {
    const current = translations[lang] || {};
    const fallback = translations.en || {};

    // Union of keys from current language and fallback
    const keys = new Set([...Object.keys(fallback), ...Object.keys(current)]);

    keys.forEach((key) => {
        const value = (key in current ? current[key] : fallback[key]) ?? "";

        // Update any elements with id *or* class matching the key
        document.querySelectorAll(`#${key}, .${key}`).forEach((el) => {
            // Use innerHTML so keys that intentionally include markup still work
            el.innerHTML = value;
        });
    });

    // Toggle language buttons visibility
    ["en", "dk", "it"].forEach((code) => {
        const btn = document.getElementById(`${code}button`);
        if (btn) btn.style.display = code === lang ? "none" : "inline-block";
    });
}

// --- Init on load + wire up buttons ---
document.addEventListener("DOMContentLoaded", () => {
    const lang = localStorage.getItem("lang") || "en";
    updateContent(lang);

    ["en", "dk", "it"].forEach((code) => {
        const btn = document.getElementById(`${code}button`);
        if (btn) btn.addEventListener("click", () => changeLanguage(code));
    });
});
/*/ Funzione per cambiare lingua
function changeLanguage(lang) {
    localStorage.setItem("lang", lang); // Salva la lingua scelta
    location.reload(); // Ricarica la pagina
}

// Attacca la funzione al contesto globale
window.changeLanguage = changeLanguage;

function updateContent(lang) {
    const texts = translations[lang];

    // Mappatura tra selettori (ID/classe) e le chiavi di 'translations'
    const contentMap = {
        "#enbutton": "enbutton",
        "#dkbutton": "dkbutton",
        "#itbutton": "itbutton",
        "#heroTitle": "heroTitle",
        "#knowMore": "knowMore",
        "#aboutTitle": "aboutTitle",
        "#viewResume": "viewResume",
        "#viewLive": "viewLive",
        "#aboutDescription": "aboutDescription",
        "#aboutGoal": "aboutGoal",
        "#sectionJob": "sectionJob",
        "#sectionProjects": "sectionProjects",
        "#sectionJob1": "sectionJob1",
        "#sectionJob2": "sectionJob2",
        "#sectionPj1": "sectionProject1",
        "#sectionPjt": "sectionTtp",
        "#sectionPj2": "sectionProject2",
        "#sectionPjt2": "sectionTtp2",
        "#sectionPj3": "sectionProject3",
        "#contactTitle": "contactTitle",
        "#contactDescription": "contactDescription",
        "#contactCta": "contactCta",
    };

    // Itera sulla mappatura e aggiorna tutti i selettori
    Object.keys(contentMap).forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        const textKey = contentMap[selector];

        if (elements.length) {
            elements.forEach((el) => {
                // Usa innerHTML per elementi specifici
                if (["#heroTitle", "#section-job1", "#section-job2", "#section-pj1", "#section-pj2", "#section-pj3", "#web-title"].includes(selector)) {
                    el.innerHTML = texts[textKey];
                } else {
                    el.innerText = texts[textKey];
                }
            });
        } else {
            console.warn(`Nessun elemento trovato per il selettore '${selector}'.`);
        }
    });
    document.getElementById("enbutton").style.display =
        lang === "en" ? "none" : "inline-block";
    document.getElementById("itbutton").style.display =
        lang === "it" ? "none" : "inline-block";
    document.getElementById("dkbutton").style.display =
        lang === "dk" ? "none" : "inline-block";
}


// Imposta la lingua all'avvio in base al localStorage
document.addEventListener("DOMContentLoaded", () => {
    const lang = localStorage.getItem("lang") || "en"; // Lingua di default
    updateContent(lang);

    // Aggiungi event listener ai pulsanti lingua
    document.getElementById("enbutton").addEventListener("click", () => {
        changeLanguage("en");
    });

    document.getElementById("dkbutton").addEventListener("click", () => {
        changeLanguage("dk");
    });

    document.getElementById("itbutton").addEventListener("click", () => {
        changeLanguage("it");
    });
});*/